import React, { useState } from 'react';
import * as momentTimezone from 'moment-timezone';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Link as MuiLink,
  Box,
} from '@mui/material';

const MeetingList = ({ meetings, onRespond }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggleExpand = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setExpanded(!expanded);
  };

  const visibleMeetings = expanded ? meetings : meetings.slice(0, 2);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }} // prevent parent click on container
    >
      <Box
        sx={{
          overflowY: expanded ? 'auto' : 'hidden',
          maxHeight: expanded ? 'none' : 350,
          pr: 1,
        }}
      >
        <Stack spacing={1}>
          {visibleMeetings.map((meeting) => {
            const hasResponded =
              meeting.responseStatus?.response?.toLowerCase() !==
              'notresponded';
            const joinLink = meeting.onlineMeeting?.joinUrl;

            const startTime = momentTimezone
              .utc(meeting.start.dateTime)
              .tz(timeZone)
              .format('DD MMM YYYY, hh:mm A');

            const endTime = momentTimezone
              .utc(meeting.end.dateTime)
              .tz(timeZone)
              .format('DD MMM YYYY, hh:mm A');

            return (
              <Card key={meeting.id} variant="outlined">
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {meeting.subject}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    marginBottom={2}
                  >
                    {startTime}-{endTime}
                  </Typography>

                  {joinLink && (
                    <Button
                      type="button"
                      variant="contained"
                      sx={{
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        fontSize: '16px',
                        background: '#007bff',
                      }}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        window.open(joinLink, '_blank');
                      }}
                    >
                      Join meeting
                    </Button>
                  )}

                  {!hasResponded ? (
                    <Stack direction="row" spacing={2} mt={2}>
                      <Button
                        variant="contained"
                        color="success"
                        onClick={(e) => onRespond(e, meeting.id, 'accept')}
                      >
                        Accept
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={(e) => onRespond(e, meeting.id, 'decline')}
                      >
                        Decline
                      </Button>
                    </Stack>
                  ) : (
                    <Typography variant="body2" color="text.secondary" mt={2}>
                      You have already{' '}
                      {meeting.responseStatus.response.toLowerCase()} this
                      meeting.
                    </Typography>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </Stack>
      </Box>
      {meetings.length > 1 && (
        <Box sx={{ textAlign: 'center', mt: 1 }}>
          <Button
            size="small"
            variant="text"
            onClick={handleToggleExpand}
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            sx={{
              fontWeight: 'bolder',
              textTransform: 'none',
              fontSize: '16px',
            }}
          >
            {expanded ? 'Show Less' : 'Show More'}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default MeetingList;
